export default __webpack_public_path__ + "img/promocode-tag.800c035.svg";